import { useSelector } from 'react-redux'
import { User } from './profile.types'
import { selectProfileData } from './useProfile'

export {selectProfileData}
export const selectUser = state => state.user
export const useUser = () => useSelector(selectUser)

export const selectFollowing = state => state.following
export const selectFollowingUser = state => selectFollowing(state).user
export const useFollowingUser = () => useSelector(selectFollowingUser)
export const selectInstanceName = ({ instance }): string => instance?.value?.instanceName
export const selectSession = state => state.session

export interface UseProfileResult {
  profile: User
  loading?: boolean
  error?: any
  isLoggedIn: boolean
}

export const useProfile = (): UseProfileResult => {
  const session = useSelector(selectSession)

  if (!session) {
    return { isLoggedIn: false, profile: undefined }
  }
  const { value: profile, loading, error } = session
  return { profile, loading, error: !profile && error, isLoggedIn: !!profile && !error }
}

export const isLoggedIn = state => !!selectProfileData(state)
export const useIsLoggedIn = () => useSelector(isLoggedIn)